(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.siteHeader = this.querySelector('#site-header');

      if (!this.header || !this.siteHeader) return;

      this.transparentHeaderEnabled = this.siteHeader.classList.contains('site-header-transparent');
      this.mainContent = document.getElementById('MainContent');
      this.isSticky = false;
      this.currentScrollTop = 0;
      this.scrollDirection = null;
      this.scrollDistance = 0;
      this.scrollTicking = false;
      this.scrollThreshold = 12;

      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.requestScrollUpdate.bind(this);
      this.onResizeHandler = this.onResize.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerRect = this.siteHeader.getBoundingClientRect();

        this.currentScrollTop = scrollTop;
        this.updateHeaderMetrics(scrollTop, headerRect);
        this.onScroll(scrollTop);
      });
    }

    requestScrollUpdate() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.onScroll();
        this.scrollTicking = false;
      });
    }

    updateHeaderMetrics(scrollTop, headerRect) {
      scrollTop ??= window.pageYOffset || document.documentElement.scrollTop;
      headerRect ??= this.siteHeader.getBoundingClientRect();

      if (!this.isSticky) {
        this.originalHeaderTop = headerRect.top + scrollTop;
      }

      this.headerHeight = headerRect.height;
      this.headerExitPoint = this.originalHeaderTop + this.headerHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onResize() {
      const wasSticky = this.isSticky;

      if (wasSticky) this.deactivateStickyHeader();
      this.updateHeaderMetrics();
      this.onScroll();
    }

    onScroll(measuredScrollTop) {
      const scrollTop = Math.max(
        typeof measuredScrollTop === 'number'
          ? measuredScrollTop
          : window.pageYOffset || document.documentElement.scrollTop,
        0
      );

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollDelta = scrollTop - this.currentScrollTop;
      const nextDirection = scrollDelta > 0 ? 'down' : scrollDelta < 0 ? 'up' : this.scrollDirection;

      if (nextDirection !== this.scrollDirection) {
        this.scrollDirection = nextDirection;
        this.scrollDistance = 0;
      }

      this.scrollDistance += Math.abs(scrollDelta);

      if (scrollTop >= this.headerExitPoint) {
        if (this.scrollDirection === 'down' && this.scrollDistance >= this.scrollThreshold) {
          this.hide();
          this.scrollDistance = 0;
        } else if (this.scrollDirection === 'up' && this.scrollDistance >= this.scrollThreshold) {
          this.reveal();
          this.scrollDistance = 0;
        } else if (!this.isSticky) {
          this.activateStickyHeader();
        }
      } else {
        this.deactivateStickyHeader();
        this.scrollDistance = 0;
      }

      this.currentScrollTop = scrollTop;
    }

    activateStickyHeader() {
      if (this.isSticky) return;

      this.isSticky = true;
      this.header.classList.add(
        'scrolled-past-header',
        'shopify-section-header-sticky',
        'animate',
        'shopify-section-header-entering'
      );
      this.header.classList.remove('shopify-section-header-hidden');
      this.siteHeader.classList.remove('site-header-transparent');

      if (!this.transparentHeaderEnabled) {
        this.mainContent?.classList.add('site-header-transition');
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.header.classList.remove('shopify-section-header-entering');
        });
      });
    }

    deactivateStickyHeader() {
      if (!this.isSticky) return;

      this.isSticky = false;
      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-sticky',
        'shopify-section-header-hidden',
        'shopify-section-header-entering',
        'animate'
      );
      this.mainContent?.classList.remove('site-header-transition');

      if (this.transparentHeaderEnabled) {
        this.siteHeader.classList.add('site-header-transparent');
      }
    }

    hide() {
      this.activateStickyHeader();
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.activateStickyHeader();
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.deactivateStickyHeader();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const desktopHeaderMenu = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('#site-header header-menu').forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');

    if (!details || !summary) return;

    const openMenu = () => {
      if (!desktopHeaderMenu.matches) return;

      document.querySelectorAll('#site-header header-menu > details[open]').forEach((openDetails) => {
        if (openDetails !== details) {
          openDetails.removeAttribute('open');
          openDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        }
      });

      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      if (!desktopHeaderMenu.matches) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    };

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', closeMenu);
    summary.addEventListener('click', (event) => {
      if (desktopHeaderMenu.matches && event.detail > 0) {
        event.preventDefault();
        openMenu();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
